/**
 * Protect a deliberate local/save seed from a stale empty remote scene.
 * The seed window is established synchronously before React commits the
 * restored tokens, so local render state must not be required here.
 * date_of_change: 2026-08-18
 */
export const shouldIgnoreEmptyRemoteStateDuringSeed = ({
  pendingSeedActive,
  incomingSceneExists
}) => Boolean(pendingSeedActive && !incomingSceneExists);
